import React, { useEffect, useRef, useState } from 'react';
import { FaPhoneAlt, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
const SESSION_KEY = 'biat-consultation-popup-shown';
function hasShown() { try { return sessionStorage.getItem(SESSION_KEY) === 'yes'; } catch { return false; } }
export default function ConsultationPopup() {
  const [open, setOpen] = useState(false);
  const dialog = useRef(null);
  const shown = useRef(hasShown());
  useEffect(() => {
    // Keep article content accessible on small screens; page contact links remain available.
    if (shown.current || window.innerWidth <= 780) return;
    let elapsed = false;
    const check = () => {
      // Let visitors finish their cookie choice before presenting a second prompt.
      if (document.querySelector('.cookie-consent')) return;
      if (!elapsed || shown.current || window.innerWidth <= 780 || document.visibilityState === 'hidden') return;
      shown.current = true;
      try { sessionStorage.setItem(SESSION_KEY, 'yes'); } catch { /* Keep the visit flag in memory. */ }
      setOpen(true);
    };
    const timer = setTimeout(() => { elapsed = true; check(); }, 10000);
    const observer = new MutationObserver(check);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('visibilitychange', check);
    return () => { clearTimeout(timer); observer.disconnect(); document.removeEventListener('visibilitychange', check); };
  }, []);
  useEffect(() => {
    if (!open || !dialog.current) return;
    const previousFocus = document.activeElement;
    const node = dialog.current;
    node.showModal();
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      node.close();
      document.body.style.overflow = previousOverflow;
      if (previousFocus?.isConnected) previousFocus.focus?.();
    };
  }, [open]);
  if (!open) return null;
  const dismiss = () => setOpen(false);
  return <dialog ref={dialog} className="consultation-popup" aria-labelledby="consultation-popup-title" aria-describedby="consultation-popup-description" onCancel={dismiss} onClick={event => { if (event.target === event.currentTarget) { const bounds = event.currentTarget.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss(); } }}>
    <div className="consultation-popup-header"><span className="consultation-popup-brand">BIAT LEGAL <small>LLP</small></span><button type="button" className="consultation-popup-close" aria-label="Close consultation popup" onClick={dismiss}>✕</button></div>
    <div className="consultation-popup-body">
      <span className="consultation-popup-eyebrow">Let’s talk about your next step</span>
      <h2 id="consultation-popup-title">Get free consultation</h2>
      <p id="consultation-popup-description">A legal question on your mind? Connect with our team for an initial conversation and understand how we can help.</p>
      <div className="consultation-popup-options">
        <a href="tel:+919999452742" onClick={dismiss}><FaPhoneAlt aria-hidden="true" /><span><strong>Call our team</strong><span>+91 9999452742</span></span><span aria-hidden="true">↗</span></a>
        <a href="https://wa.me/919999452742" target="_blank" rel="noopener noreferrer" onClick={dismiss}><FaWhatsapp aria-hidden="true" /><span><strong>Chat on WhatsApp</strong><span>Start a conversation</span></span><span aria-hidden="true">↗</span></a>
        <a href="mailto:info@biatlegal.com" onClick={dismiss}><FaEnvelope aria-hidden="true" /><span><strong>Email us</strong><span>info@biatlegal.com</span></span><span aria-hidden="true">↗</span></a>
      </div>
      <p className="consultation-popup-note">No form to fill. Choose the way you prefer to connect.</p>
      <button type="button" className="consultation-popup-later" onClick={dismiss}>Maybe later</button>
    </div>
  </dialog>;
}
